import * as React from 'react';
import classNames from 'classnames';
import BaseSectionWithAnalyticsContext from '../../common/BaseSection/BaseSectionWithAnalyticsContext.esm.js';
import { NvMarkdownInline, NvMarkdown } from '@invitae/ids-react';
import styles from './HeroTextBlock.module.esm.js';

var HeroTextBlock = function (_a) {
    var _b = _a.fields, heading = _b.heading, body = _b.body, theme = _b.theme, analyticsEvents = _b.analyticsEvents, internalName = _b.internalName, id = _a.id, dataCy = _a["data-cy"];
    return (React.createElement(BaseSectionWithAnalyticsContext, { analyticsEvents: analyticsEvents, className: classNames(styles.root, styles[theme]), "data-cy": dataCy, id: id, sectionName: internalName },
        React.createElement("div", { className: "nv-container" },
            React.createElement("div", { className: "nv-grid" },
                React.createElement("div", { className: styles.gridElement },
                    React.createElement(NvMarkdownInline, { className: styles.heading, elementWrapper: "h1" }, heading),
                    body && React.createElement(NvMarkdown, { className: styles.body }, body))))));
};

export { HeroTextBlock as default };
//# sourceMappingURL=HeroTextBlock.esm.js.map
